// extracted by mini-css-extract-plugin
export default {"modal-buttons-container":"classes_modal-buttons-container__QxpSm","logo-mid":"classes_logo-mid__AKRLr","loader-container":"classes_loader-container__6hx0k"};